module.exports = __webpack_public_path__ + "pc/img/ic_nav.2fa362f7.svg";